import React from 'react';

const Instructions = ({ showInstructions, setShowInstructions }) => {
    if (!showInstructions) return null;

    return (
        <div className="container mb-4">
            <div className="row">
                <div className="col-md-10 offset-md-1 p-4 shadow rounded bg-light">
                    <div className="d-flex justify-content-between align-items-start">
                        <h4 className="mb-3 fs-5">Instructions</h4>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => setShowInstructions(false)}
                        ></button>
                    </div>
                    <p className="small">Welcome to the DC Tech Admin Portal. This portal provides tools for managing various DC projects:</p>
                    <ul className="small">
                        <li><strong>IP Address Whitelist</strong> - Add IP address to allow list for various environments</li>
                        <li><strong>ECS Service Manager</strong> - Turn on or shut down services in DC Client test environments</li>
                        <li><strong>Database Download</strong> - Generate links to download DC Client database dumps for development</li>
                        <li><strong>Tool Box</strong> - Additional utilities like Checking your IP address</li>
                    </ul>
                    <p className="mb-0 text-muted small">Select a project tab above to access the relevant tools.</p>
                </div>
            </div>
        </div>
    );
};

export default Instructions; 